import axios from "axios";
import { bazzarSearchOrderApiUrl, indianPostTrackApiUrl, shipmentsGetApiUrl, shopOrderLogisticTrackingDashboardUrl, shopOrderLogisticUrl } from "../constants/apis";
import { getUserToken } from "../helpers/local_storage_helpers";

export const postShipment = async (data) => {
    const config = {
        headers: {
            "Authorization": `Token ${getUserToken()}`,
        },
    };
    const response = await axios.post(shopOrderLogisticUrl, data, config);
    return response;
};

export const patchShipment = async (data, id) => {
    const config = {
        headers: {
            "Authorization": `Token ${getUserToken()}`,
        },
    };
    const response = await axios.patch(shopOrderLogisticUrl + id + "/", data, config);
    return response;
};

export const deleteShipment = async (id) => {
    const config = {
        headers: {
            "Authorization": `Token ${getUserToken()}`,
        },
    };
    const response = await axios.delete(shopOrderLogisticUrl + id + "/", config);
    return response;
};

export const getShipments = async (query) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Token ${getUserToken()}`,
        },
    };

    const response = await axios.get(shipmentsGetApiUrl + query, config);

    return response;
};

export const getShippingTrackingDashboard = async (params = {}, additionalConfig = {}) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Token ${getUserToken()}`,
        },
        params,
        ...additionalConfig,
    };

    const response = await axios.get(shopOrderLogisticTrackingDashboardUrl, config);
    return response;
};

export const searchOrder = async (query) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Token ${getUserToken()}`,
        },
    };

    const response = await axios.get(bazzarSearchOrderApiUrl + query, config);
    return response;
};

export const trackIndianPost = async (trackingNumber) => {
    const config = {
        headers: {
            "Authorization": `Token ${getUserToken()}`,
        },
    };
    const response = await axios.get(`${indianPostTrackApiUrl}?tracking_number=${trackingNumber}`, config);
    return response;
};